/**
 * クエリパラメータを更新する
 *
 * - searchParamsの中のkeyに対してvalueの値を設定する
 * - もしvalueが空文字列の場合はkeyを削除する
 *
 * @param searchParams 検索パラメータ
 * @param key キー
 * @param value 値
 * @returns 更新後の検索パラメータ
 */
export const updateSearchParam = (
  searchParams: URLSearchParams,
  key: string,
  value: string
): URLSearchParams => {
  // URLSearchParamsはimmutableなので、新しいインスタンスを作成する
  const params = new URLSearchParams(searchParams);

  if (value) {
    params.set(key, value);
  } else {
    params.delete(key);
  }

  return params;
};
